import React, { useContext, useEffect, useState } from 'react';
import { ServiceResponse } from '../../../app/services/shared/interfaces';
import LazyLoading from '../../../components/LazyLoading';
import { AppContext } from '../../../contexts/AppContext';
import useReactConfirmAlert from '../../../hooks/useReactConfirmAlert';
import { toast } from 'react-toastify';
import useBusinessNameContactService from '../../../app/services/hooks/useBusinessNameContactService';
import { BusinessNameContactDataForm } from '../../../app/models/BusinessNameContact';
import { ContactType } from '../../../app/models/ContactType';
import ButtonCancelForm from '../../../components/buttons/ButtonCancelForm';
import ButtonSaveForm from '../../../components/buttons/ButtonSaveForm';
import BusinessNameContactForm from './forms/BusinessNameContactForm';

interface Props {
    businessNameContactId: number;
    onSaved?: () => void;
    onCancel?: () => void;
    onError?: () => void;
}

const BusinessNameContactEdit = ({ businessNameContactId, onSaved, onCancel, onError }: Props) => {
    const { showLoading, hideLoading, changeAnimation } = useContext(AppContext);
    const { fetchingEditBusinessNameContact, editBusinessNameContact, fetchingUpdateBusinessNameContact, updateBusinessNameContact } =
        useBusinessNameContactService();

    const [businessNameContact, setBusinessNameContact] = useState<BusinessNameContactDataForm>(
        { 
            name: '', 
            email: '', 
            contact_type_id: 0 
        }
    );
    const [contactTypes, setContactTypes] = useState<ContactType[]>([]);
    const [errorFields, setErrorFields] = useState<any>();

    useEffect(() => {
        edit();
    }, []);

    const edit = () => {
        if (showLoading) showLoading('loading', 'Cargando contacto...');
        editBusinessNameContact(businessNameContactId, {
            onSuccess: (response: ServiceResponse) => {
                setContactTypes(response.data.contact_types);
                setBusinessNameContact(response.data.business_name_contact);
                if (hideLoading) hideLoading();
            },
            onError: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();
                toast.error(response.message);
                if (onError) onError();
            }
        });
    };

    const update = () => {
        if (showLoading) showLoading('loading', 'Actualizando contacto...');
        updateBusinessNameContact(businessNameContactId, businessNameContact, {
            onSuccess: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();

                useReactConfirmAlert().successAlert({
                    title: 'Éxito',
                    message: response.message
                });
                toast.success(response.message, {
                    autoClose: 2500
                });
                if (onSaved) onSaved();
            },
            onError: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();

                useReactConfirmAlert().errorAlert({
                    title: 'Error',
                    message: response.message
                });
            },
            onFieldError: (errorFields: ServiceResponse) => {
                if (hideLoading) hideLoading();
                setErrorFields(errorFields.data);
            }
        });
    };

    const cancel = () => {
        if (onCancel) onCancel();
    };

    return fetchingEditBusinessNameContact ? (
        <LazyLoading height={300} />
    ) : (
        <>
            <div className="row">
                <div className="col-12">
                    <BusinessNameContactForm
                        businessNameContactDataForm={businessNameContact}
                        setBusinessNameContactDataForm={setBusinessNameContact}
                        contactTypes={contactTypes}
                        errorFields={errorFields}
                    />
                </div>
            </div>
            <hr />
            <div className="row justify-content-end">
                <div className="col-auto">
                    <ButtonCancelForm
                        callbackCancel={cancel}
                        locked={fetchingUpdateBusinessNameContact}
                    />
                </div>
                <div className="col-auto">
                    <ButtonSaveForm callbackSave={update} locked={fetchingUpdateBusinessNameContact} />
                </div>
            </div>
        </>
    );
};

export default BusinessNameContactEdit;
